/*
 * @Description:
 * @Author: jia.chen02
 * @Date: 2026-02-10 13:45:38
 * @LastEditors: jia.chen02
 * @LastEditTime: 2026-03-12 17:26:04
 */
/**
 * 数据分析模块接口
 * @description 旅游产品数据大屏相关接口
 */

import axios from "@/utils/request";
import Api from "../api";
import * as Request from "../request.type";

/**
 * 获取今日&近30日交易数据
 * @returns 交易数据统计
 */
export const Http_getRecentTrades = async (
  params?: Request.GetSpecificRateParams
) => {
  return await axios.get(Api.GET_RECENT_TRADES, {
    params,
  });
};

/**
 * 获取供应商列表
 * @param params 查询参数
 * @returns 供应商列表
 */
export const Http_getSupplierList = async (
  params?: Request.GetSupplierListParams
) => {
  return await axios.get(Api.GET_REPORT_SUPPLIER_TOUR_PRODUCT_SUPPLIER_LIST, {
    params,
  });
};

/**
 * 获取渠道占比数据
 * @param params 查询参数
 * @returns 渠道占比数据
 */
export const Http_getChannelRate = async (
  params: Request.GetSpecificRateParams
) => {
  return await axios.get(Api.GET_CHANNEL_RATE, {
    params,
  });
};

/**
 * 获取销售数据统计
 * @param params 查询参数
 * @returns 销售数据统计
 */
export const Http_getSalesData = async (
  params: Request.GetSpecificRateParams
) => {
  return await axios.get(Api.GET_SALES_DATA, {
    params,
  });
};

/**
 * 获取供应商销售排名
 * @param params 查询参数
 * @returns 供应商销售排名数据
 */
export const Http_getSupplierRank = async (
  params: Request.GetSupplierRankParams
) => {
  return await axios.post(Api.POST_SUPPLIER_RANK, params);
};

/**
 * 获取供应商产品排名
 * @param params 查询参数
 * @returns 供应商产品排名数据
 */
export const Http_getSupplierProductRank = async (
  params: Request.GetSupplierProductRankParams
) => {
  return await axios.post(Api.POST_SUPPLIER_PRODUCT_RANK, params);
};

/**
 * 获取销售单位套数排名（前20，不区分币种）
 * @param params 查询参数
 * @returns 销售单位套数排名数据
 */
export const Http_getSaleUnitPackNum = async (
  params: Request.GetSaleUnitPackNumParams
) => {
  return await axios.post(Api.POST_SALE_UNIT_PACK_NUM, params);
};

// 导出命名空间的方式，便于组织管理
export const DataAnalysisApi = {
  Http_getRecentTrades,
  Http_getSupplierList,
  Http_getChannelRate,
  Http_getSalesData,
  Http_getSupplierRank,
  Http_getSupplierProductRank,
  Http_getSaleUnitPackNum,
};
